import { OnInit, OnDestroy, Directive, Input, ViewContainerRef, TemplateRef } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Roles } from '../models/auth/role.model';
import { AuthService } from 'src/app/auth/auth.service';

@Directive({
    selector: '[appHasPermission]'
})
export class HasPermissionDirective implements OnInit, OnDestroy {

    // the role | roles the user must have
    @Input() appHasPermission: Roles | Roles[];

    stop$ = new Subject();

    isVisible = false;

    /**
     * @param {ViewContainerRef} viewContainerRef
     * 	the location where the templateRef will be render
     * @param {TemplateRef<any>} templateRef
     *  the templateRef to be rendered
     * @param {RolesService} authService
     *  gives access to user observable
     */
    constructor(
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<any>,
        private authService: AuthService
    ) { }

    ngOnInit() {

        this.authService.authEmployee$.pipe(
            takeUntil(this.stop$)
        ).subscribe(authEmployee => {

            if (!authEmployee || !authEmployee.user.roles.length) {
                this.viewContainerRef.clear();
            }

            let hasPermission = false;
            if (typeof this.appHasPermission === 'string') {
                hasPermission = authEmployee.user.roles.includes(this.appHasPermission);
            } else {
                hasPermission = authEmployee.user.roles.some(role => this.appHasPermission.includes(role));
            }

            if (hasPermission) {

                if (!this.isVisible) {

                    this.isVisible = true;
                    this.viewContainerRef.createEmbeddedView(this.templateRef);
                }
            } else {

                this.isVisible = false;
                this.viewContainerRef.clear();
            }
        });
    }

    // Clear the subscription on destroy
    ngOnDestroy() {
        this.stop$.next();
    }
}
